import React from 'react';
import { Typography, Box, TextField, Checkbox, FormControlLabel, Radio } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import { Field } from 'formik';
import { FormHelperText } from '@material-ui/core';

function ChildDevelopment({ errors, touched, values, setFieldValue, }) {

  return (
    <Box>
      <Typography fontWeight="bold" mb={1}>
        II. Child Development
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={12} md={6}>
          <Box display="flex" flexDirection="column">
            <Box mb={2}>
              <Typography>
                1. Ano ang edad ng mga batang kalaro ng inyong anak? <span style={{color: 'error.main'}} aria-hidden="true">*</span><span className="sr-only">required</span>
              </Typography>
              <FormControlLabel
                control={
                  <Radio
                    name="childPlaymatesAge"
                    checked={values.childPlaymatesAge === 'Ka-edad ng bata'}
                    onChange={() => setFieldValue('childPlaymatesAge', 'Ka-edad ng bata')}
                    aria-required="true"
                  />
                }
                label="Ka-edad ng bata"
              />
              <FormControlLabel
                control={
                  <Radio
                    name="childPlaymatesAge"
                    checked={values.childPlaymatesAge === 'Mas bata'}
                    onChange={() => setFieldValue('childPlaymatesAge', 'Mas bata')}
                  />
                }
                label="Mas bata"
              />
              <FormControlLabel
                control={
                  <Radio
                    name="childPlaymatesAge"
                    checked={values.childPlaymatesAge === 'Mas nakatatanda'}
                    onChange={() => setFieldValue('childPlaymatesAge', 'Mas nakatatanda')}
                  />
                }
                label="Mas nakatatanda"
              />
              {errors.childPlaymatesAge && touched.childPlaymatesAge && (
                <FormHelperText error>{errors.childPlaymatesAge}</FormHelperText>
              )}
            </Box>
            <Box mb={2}>
              <Typography>
                2. Mayroon bang problema ang bata sa pag nahiwalay sa: <span style={{color: 'red'}}>*</span>
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    name="childSeparationIssues"
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childSeparationIssues', [...values.childSeparationIssues, "Nanay"]);
                      } else {
                        setFieldValue('childSeparationIssues', values.childSeparationIssues.filter((lang) => lang !== "Nanay"))
                      }
                    }} />
                }
                label="Nanay"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="childSeparationIssues"
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childSeparationIssues', [...values.childSeparationIssues, "Tatay"]);
                      } else {
                        setFieldValue('childSeparationIssues', values.childSeparationIssues.filter((lang) => lang !== "Tatay"))
                      }
                    }} />
                }
                label="Tatay"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="childSeparationIssues"
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childSeparationIssues', [...values.childSeparationIssues, "At iba pa"]);
                      } else {
                        setFieldValue('childSeparationIssues', values.childSeparationIssues.filter((lang) => lang !== "At iba pa"))
                      }
                    }} />
                }
                label="At iba pa"
              />
              {values.childSeparationIssues.includes("At iba pa") && (
                <Box mt={1}>
                  <Field
                    as={TextField}
                    name="specificSeparationIssue"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Specify *"
                    size="small"
                    fullWidth
                    helperText={touched.specificSeparationIssue && errors.specificSeparationIssue}
                    error={errors.specificSeparationIssue && touched.specificSeparationIssue}
                  />
                </Box>
              )}
              {errors.childSeparationIssues && touched.childSeparationIssues && (
                <FormHelperText error>{errors.childSeparationIssues}</FormHelperText>
              )}
            </Box>
            <Box mb={2}>
              <Typography>
                3. Ano ang lenggwaheng ginagamit ng bata?
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    name="childLanguagesUse"
                    checked={values.childLanguagesUse.includes("English")}
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childLanguagesUse', [...values.childLanguagesUse, "English"]);
                      } else {
                        setFieldValue('childLanguagesUse', values.childLanguagesUse.filter((lang) => lang !== "English"))
                      }
                    }}
                  />
                }
                label="English"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="childLanguagesUse"
                    checked={values.childLanguagesUse.includes("Filipino")}
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childLanguagesUse', [...values.childLanguagesUse, "Filipino"]);
                      } else {
                        setFieldValue('childLanguagesUse', values.childLanguagesUse.filter((lang) => lang !== "Filipino"))
                      }
                    }}
                  />
                }
                label="Filipino"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="childLanguagesUse"
                    onChange={(event) => {
                      if (event.target.checked) {
                        setFieldValue('childLanguagesUse', [...values.childLanguagesUse, "At iba pa"]);
                      } else {
                        setFieldValue('childLanguagesUse', values.childLanguagesUse.filter((lang) => lang !== "At iba pa"))
                      }
                    }} />
                }
                label="At iba pa"
              />
              {values.childLanguagesUse.includes("At iba pa") && (
                <Box mt={1}>
                  <Field
                    as={TextField}
                    name="specificChildLanguagesUse"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Specify *"
                    size="small"
                    fullWidth
                    helperText={touched.specificChildLanguagesUse && errors.specificChildLanguagesUse}
                    error={errors.specificChildLanguagesUse && touched.specificChildLanguagesUse}

                  />
                </Box>
              )}
              {errors.childLanguagesUse && touched.childLanguagesUse && (
                <FormHelperText error>{errors.childLanguagesUse}</FormHelperText>
              )}
            </Box>
            <Box mb={2}>
              <Typography>
                4. Saan nahihirapan ang batang may kapansanan? <span style={{color: 'red'}}>*</span>
              </Typography>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.showTextFieldA}
                      onChange={() =>
                        setFieldValue('showTextFieldA', !values.showTextFieldA)
                      }
                    />
                  }
                  label="A. Pag galaw"
                />
                {values.showTextFieldA && (
                  <Box ml={2} mb={3}>
                    <Grid container spacing={2}>
                      <Grid item md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("imitation")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "imitation"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "imitation"))
                                  }
                                }}
                              />
                            }
                            label="Paggaya ng galaw (imitation)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("crawls")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "crawls"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "crawls"))
                                  }
                                }}
                              />
                            }
                            label="Paggapang (crawls)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("sitting")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "sitting"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "sitting"))
                                  }
                                }}
                              />
                            }
                            label="Pagupo nang mag-isa (sitting)"
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("standing")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "standing"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "standing"))
                                  }
                                }}
                              />
                            }
                            label="Pagtayo (standing)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("walking")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "walking"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "walking"))
                                  }
                                }}
                              />
                            }
                            label="Paglakad (walking)"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childPhysicalChallenges.includes("going up and down the stairs")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childPhysicalChallenges', [...values.childPhysicalChallenges, "going up and down the stairs"]);
                                  } else {
                                    setFieldValue('childPhysicalChallenges', values.childPhysicalChallenges.filter((value) => value !== "going up and down the stairs"))
                                  }
                                }}
                              />
                            }
                            label="Pagakyat sa hagdanan (going up and down the stairs)"
                          />
                        </Box>

                      </Grid>
                      {errors.childPhysicalChallenges && touched.childPhysicalChallenges && (
                        <Box px={1}>
                          <FormHelperText error>{errors.childPhysicalChallenges}</FormHelperText>
                        </Box>
                      )}
                    </Grid>
                    <Grid item md={12}>
                      <Typography mt={2}>
                        Lagyan ng (✔) kung:
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.childModeOfMobility.includes("Naka Wheelchair")}
                            onChange={(event) => {
                              if (event.target.checked) {
                                setFieldValue('childModeOfMobility', [...values.childModeOfMobility, "Naka Wheelchair"]);
                              } else {
                                setFieldValue('childModeOfMobility', values.childModeOfMobility.filter((value) => value !== "Naka Wheelchair"))
                              }
                            }}
                          />
                        }
                        label="Naka Wheelchair"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.childModeOfMobility.includes("Kinakarga")}
                            onChange={(event) => {
                              if (event.target.checked) {
                                setFieldValue('childModeOfMobility', [...values.childModeOfMobility, "Kinakarga"]);
                              } else {
                                setFieldValue('childModeOfMobility', values.childModeOfMobility.filter((value) => value !== "Kinakarga"))
                              }
                            }}
                          />
                        }
                        label="Kinakarga"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.childModeOfMobility.includes("Nakakalakad")}
                            onChange={(event) => {
                              if (event.target.checked) {
                                setFieldValue('childModeOfMobility', [...values.childModeOfMobility, "Nakakalakad"]);
                              } else {
                                setFieldValue('childModeOfMobility', values.childModeOfMobility.filter((value) => value !== "Nakakalakad"))
                              }
                            }}
                          />
                        }
                        label="Nakakalakad"
                      />
                    </Grid>
                    {errors.childModeOfMobility && touched.childModeOfMobility && (
                      <FormHelperText>{errors.childModeOfMobility}</FormHelperText>
                    )}
                  </Box>
                )}
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.showTextFieldB}
                      onChange={() => setFieldValue('showTextFieldB', !values.showTextFieldB)
                      }
                    />
                  }
                  label="B. Pandama"
                />
                {values.showTextFieldB && (
                  <Box ml={2} mb={3}>
                    <Grid container spacing={2}>
                      <Grid item md={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childSensesChallenges.includes("Paningin")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childSensesChallenges', [...values.childSensesChallenges, "Paningin"]);
                                } else {
                                  setFieldValue('childSensesChallenges', values.childSensesChallenges.filter((value) => value !== "Paningin"))
                                }
                              }}
                            />
                          }
                          label="Paningin"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childSensesChallenges.includes("Pandinig")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childSensesChallenges', [...values.childSensesChallenges, "Pandinig"]);
                                } else {
                                  setFieldValue('childSensesChallenges', values.childSensesChallenges.filter((value) => value !== "Pandinig"))
                                }
                              }}
                            />
                          }
                          label="Pandinig"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childSensesChallenges.includes("Pang-hawak")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childSensesChallenges', [...values.childSensesChallenges, "Pang-hawak"]);
                                } else {
                                  setFieldValue('childSensesChallenges', values.childSensesChallenges.filter((value) => value !== "Pang-hawak"))
                                }
                              }}
                            />
                          }
                          label="Pang-hawak"
                        />
                        {errors.childSensesChallenges && touched.childSensesChallenges && (
                          <FormHelperText>{errors.childSensesChallenges}</FormHelperText>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.showTextFieldC}
                      onChange={() => setFieldValue('showTextFieldC', !values.showTextFieldC)}
                    />
                  }
                  label="C. Pag iisip"
                />
                {values.showTextFieldC && (
                  <Box ml={2} mb={3}>
                    <Typography>
                      Mga konsepto tulad ng:
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("letra o letters")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "letra o letters"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "letra o letters"))
                                  }
                                }}
                              />
                            }
                            label="letra o letters"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("numero o numbers")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "numero o numbers"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "numero o numbers"))
                                  }
                                }}
                              />
                            }
                            label="numero o numbers"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("kulay o colors")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "kulay o colors"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "kulay o colors"))
                                  }
                                }}
                              />
                            }
                            label="kulay o colors"
                          />
                        </Box>
                      </Grid>
                      <Grid item md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("hugis o shapes")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "hugis o shapes"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "hugis o shapes"))
                                  }
                                }}
                              />
                            }
                            label="hugis o shapes"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("parte ng katawan o body parts")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "parte ng katawan o body parts"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "parte ng katawan o body parts"))
                                  }
                                }}
                              />
                            }
                            label="parte ng katawan o body parts"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childCognitiveChallenges.includes("posisyon o positional concepts")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childCognitiveChallenges', [...values.childCognitiveChallenges, "posisyon o positional concepts"]);
                                  } else {
                                    setFieldValue('childCognitiveChallenges', values.childCognitiveChallenges.filter((value) => value !== "posisyon o positional concepts"))
                                  }
                                }}
                              />
                            }
                            label="posisyon o positional concepts"
                          />
                        </Box>
                      </Grid>
                      {errors.childCognitiveChallenges && touched.childCognitiveChallenges && (
                        <Box px={1}>
                          <FormHelperText>{errors.childCognitiveChallenges}</FormHelperText>
                        </Box>
                      )}
                    </Grid>
                    <Grid item md={12}>
                      <Box display="flex" flexDirection="column">
                        <Typography mt={2}>
                          Sumusunod sa panuto
                        </Typography>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={values.childFollowingInstructions === '1'}
                              onChange={() => setFieldValue('childFollowingInstructions', '1')}
                            />
                          }
                          label="1-2 simpleng panuto (kuha, bigay, lagay, atbp.)"
                        />
                        <FormControlLabel
                          control={
                            <Radio
                              checked={values.childFollowingInstructions === '2'}
                              onChange={() => setFieldValue('childFollowingInstructions', '2')}
                            />
                          }
                          label="2-3 simpleng panuto (kuha at bigay, lagay at ibalik, atbp.)"
                        />
                        {errors.childFollowingInstructions && touched.childFollowingInstructions && (
                          <FormHelperText>{errors.childFollowingInstructions}</FormHelperText>
                        )}
                      </Box>
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.showTextFieldD}
                      onChange={() => setFieldValue('showTextFieldD', !values.showTextFieldD)}
                    />
                  }
                  label="D. Pag-uugali o Pakikitungo"
                />
                {values.showTextFieldD && (
                  <Box ml={2} mb={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childAttitudeChallenges.includes("Makatanggal sa gawain")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childAttitudeChallenges', [...values.childAttitudeChallenges, "Makatanggal sa gawain"]);
                                  } else {
                                    setFieldValue('childAttitudeChallenges', values.childAttitudeChallenges.filter((value) => value !== "Makatanggal sa gawain"))
                                  }
                                }}
                              />
                            }
                            label="Makatanggal sa gawain"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childAttitudeChallenges.includes("Nakakapag-hintay")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childAttitudeChallenges', [...values.childAttitudeChallenges, "Nakakapag-hintay"]);
                                  } else {
                                    setFieldValue('childAttitudeChallenges', values.childAttitudeChallenges.filter((value) => value !== "Nakakapag-hintay"))
                                  }
                                }}
                              />
                            }
                            label="Nakakapag-hintay"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childAttitudeChallenges.includes("Pagiging galit nang hindi nananakit ng sarili at kapwa")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childAttitudeChallenges', [...values.childAttitudeChallenges, "Pagiging galit nang hindi nananakit ng sarili at kapwa"]);
                                  } else {
                                    setFieldValue('childAttitudeChallenges', values.childAttitudeChallenges.filter((value) => value !== "Pagiging galit nang hindi nananakit ng sarili at kapwa"))
                                  }
                                }}
                              />
                            }
                            label="Pagiging galit nang hindi nananakit ng sarili at kapwa"
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box display="flex" flexDirection="column">
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childAttitudeChallenges.includes("Umupo upang tapusin ang gawain")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childAttitudeChallenges', [...values.childAttitudeChallenges, "Umupo upang tapusin ang gawain"]);
                                  } else {
                                    setFieldValue('childAttitudeChallenges', values.childAttitudeChallenges.filter((value) => value !== "Umupo upang tapusin ang gawain"))
                                  }
                                }}
                              />
                            }
                            label="Umupo upang tapusin ang gawain"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.childAttitudeChallenges.includes("Sumusunod sa panuto")}
                                onChange={(event) => {
                                  if (event.target.checked) {
                                    setFieldValue('childAttitudeChallenges', [...values.childAttitudeChallenges, "Sumusunod sa panuto"]);
                                  } else {
                                    setFieldValue('childAttitudeChallenges', values.childAttitudeChallenges.filter((value) => value !== "Sumusunod sa panuto"))
                                  }
                                }}
                              />
                            }
                            label="Sumusunod sa panuto"
                          />
                        </Box>
                      </Grid>
                      {errors.childAttitudeChallenges && touched.childAttitudeChallenges && (
                        <Box px={1}>
                          <FormHelperText>{errors.childAttitudeChallenges}</FormHelperText>
                        </Box>
                      )}
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Typography mt={2}>
                        Lagyan ng (✔) ang mga ugaling nakikita sa bata:
                      </Typography>
                      <Box
                        sx={{
                          display: { xs: 'flex', sm: 'flex', md: 'block' },
                          flexDirection: { xs: 'column', sm: 'column' },
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Agresibo")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Agresibo"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Agresibo"))
                                }
                              }}
                            />
                          }
                          label="Agresibo"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Mahiyain")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Mahiyain"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Mahiyain"))
                                }
                              }}
                            />
                          }
                          label="Mahiyain"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Matulungin")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Matulungin"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Matulungin"))
                                }
                              }}
                            />
                          }
                          label="Matulungin"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Palakaibigan")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Palakaibigan"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Palakaibigan"))
                                }
                              }}
                            />
                          }
                          label="Palakaibigan"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Masiyahin")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Masiyahin"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Masiyahin"))
                                }
                              }}
                            />
                          }
                          label="Masiyahin"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Pakikipaglaro")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Pakikipaglaro"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Pakikipaglaro"))
                                }
                              }}
                            />
                          }
                          label="Pakikipaglaro"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childBehaviorChallenges.includes("Maingat")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childBehaviorChallenges', [...values.childBehaviorChallenges, "Maingat"]);
                                } else {
                                  setFieldValue('childBehaviorChallenges', values.childBehaviorChallenges.filter((value) => value !== "Maingat"))
                                }
                              }}
                            />
                          }
                          label="Maingat"
                        />
                      </Box>
                      {errors.childBehaviorChallenges && touched.childBehaviorChallenges && (
                        <FormHelperText>{errors.childBehaviorChallenges}</FormHelperText>
                      )}
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={values.showTextFieldE}
                      onChange={() => setFieldValue('showTextFieldE', !values.showTextFieldE)}
                    />
                  }
                  label="E. Pagsasalita o Pakikipag-usap"
                />
                {values.showTextFieldE && (
                  <Box ml={2} mb={3}>
                    <Grid item md={12}>
                      <Box display="flex" flexDirection="column">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("I-turo ang gusto at kailangan")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "I-turo ang gusto at kailangan"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "I-turo ang gusto at kailangan"))
                                }
                              }}
                            />
                          }
                          label="I-turo ang gusto at kailangan"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("Sabihin ang gusto at kailangan")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "Sabihin ang gusto at kailangan"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "Sabihin ang gusto at kailangan"))
                                }
                              }}
                            />
                          }
                          label="Sabihin ang gusto at kailangan"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("Sabihin ang mga tunog ng letra nang malinaw")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "Sabihin ang mga tunog ng letra nang malinaw"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "Sabihin ang mga tunog ng letra nang malinaw"))
                                }
                              }}
                            />
                          }
                          label="Sabihin ang mga tunog ng letra nang malinaw"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("Magkusang kumausap sa ibang tao o initiates conversation")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "Magkusang kumausap sa ibang tao o initiates conversation"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "Magkusang kumausap sa ibang tao o initiates conversation"))
                                }
                              }}
                            />
                          }
                          label="Magkusang kumausap sa ibang tao o initiates conversation"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("Magsabi ng oo/yes o hindi/no")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "Magsabi ng oo/yes o hindi/no"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "Magsabi ng oo/yes o hindi/no"))
                                }
                              }}
                            />
                          }
                          label="Magsabi ng oo/yes o hindi/no"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.childInteractionChallenges.includes("Sumagot sa mga tanong kagaya ng “ano?”")}
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setFieldValue('childInteractionChallenges', [...values.childInteractionChallenges, "Sumagot sa mga tanong kagaya ng “ano?”"]);
                                } else {
                                  setFieldValue('childInteractionChallenges', values.childInteractionChallenges.filter((value) => value !== "Sumagot sa mga tanong kagaya ng “ano?”"))
                                }
                              }}
                            />
                          }
                          label="Sumagot sa mga tanong kagaya ng “ano?”"
                        />
                        {errors.childInteractionChallenges && touched.childInteractionChallenges && (
                          <FormHelperText>{errors.childInteractionChallenges}</FormHelperText>
                        )}
                      </Box>
                    </Grid>
                  </Box>
                )}
              </Box>
            </Box>
            <Box>
              <Typography fontWeight="bold">
                Paki-screenshot ang Reference Number at I-send sa Official Facebook Page QC Kabahagi Center 
                para maibigay ang susunod na detalye patungkol sa susunod na hakbang ng inyong application.<span style={{color: 'red'}}>*</span>
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={values.terms === 'Yes'}
                    onChange={() => setFieldValue('terms', 'Yes')}
                  />
                }
                label="Sumasang-ayon ako sa pahayag na ito."
              />
              {errors.terms && touched.terms && (
                <FormHelperText>{errors.terms}</FormHelperText>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ChildDevelopment